export default {
  title: 'Model Composer',
  emptyState: 'Adicione um canal para começar.',
  channelsPending: 'Complete o canal novo: indique onde ele satura e suas vendas nesse ponto. | Complete os {count} canais pendentes: indique onde cada um satura e suas vendas nesse ponto.',
  channelsCompare: 'Curvas de saturação',
  // Etapas, e por que Próximo fica desabilitado em cada uma.
  stepDetails: 'Configuração',
  stepChannels: 'Canais de mídia',
  stepSpend: 'Investimento em mídia',
  stepRevenue: 'Vendas',
  stepOtherInputs: 'Outros inputs',
  stepFutureTrends: 'Tendências futuras',
  stepPreview: 'Prévia',
  stepHintSource: 'Escolha como começar.',
  stepHintDetails: 'Informe um nome e um mercado para continuar.',
  stepHintCopyModel: 'Escolha um modelo para copiar e continuar.',
  stepHintChannels: 'Adicione pelo menos um canal para continuar.',
  stepHintRevenue: 'Informe as vendas totais para continuar.',
  create: 'Criar modelo',
  name: 'Nome do modelo',
  nameRequired: 'O nome é obrigatório.',
  market: 'Mercado',
  currency: 'Moeda',
  frequency: 'Frequência',
  frequencyMonthly: 'Mensal',
  frequencyWeekly: 'Semanal',
  history: 'Histórico',
  historyYears: '{n} ano | {n} anos',
  comingSoon: 'Em breve',
  addKpi: 'Adicionar KPI',
  addInput: 'Adicionar input',
  // Future trends
  futureTrendsIntro: 'Opcional. Quanto se espera que cada série cresça nos próximos 12 meses. 0% significa igual ao ano passado.',
  growthSales: 'Vendas',
  growthSalesInfo: 'Crescimento esperado das vendas totais nos próximos 12 meses, como uma faixa.',
  growthMedia: 'Investimento em mídia',
  growthMediaInfo: 'Crescimento esperado do investimento nos canais deste modelo nos próximos 12 meses.',
  growthOtherInfo: 'Crescimento esperado deste investimento nos próximos 12 meses.',
  growthMin: 'Crescimento mín.',
  growthMax: 'Crescimento máx.',
  growthLastYear: 'Últimos 12 meses',
  growthNextYear: 'Próximos 12 meses',
  growthChange: 'Variação',
  growthNoChange: 'Igual ao ano passado',
  growthPastGroup: 'Últimos 12 meses',
  growthFutureGroup: 'Próximos 12 meses (esperado)',
  growthPastColumn: 'Ano passado',
  growthNextColumn: 'Próximo ano',
  growthLegendPast: 'Informado',
  growthLegendFuture: 'Faixa esperada',
  growthLegendMark: 'Mesmo mês do ano passado',
  recapFutureTrends: 'Crescimento de vendas',
  // Outros inputs
  otherInputsIntro: 'Opcional. Outros investimentos que o modelo deve considerar.',
  otherComarketing: 'Co-marketing',
  otherComarketingInfo: 'Investimento da marca fora desta categoria, como publicidade institucional. Só é preciso o total.',
  otherCompetition: 'Concorrência',
  otherCompetitionInfo: 'Investimento total em mídia dos concorrentes diretos nesta categoria.',
  otherTotal: 'Investimento total',
  otherAvgMonthInfo: 'Média mensal. Ao editá-la, o total é atualizado.',
  otherFlatten: 'Suavizar: deixar os meses mais uniformes',
  otherRandomize: 'Aleatorizar: deixar os meses mais irregulares',
  otherShiftLeft: 'Antecipar um mês',
  otherShiftRight: 'Adiar um mês',
  otherClear: 'Limpar',
  otherAttribution: 'Atribuição (% das vendas)',
  otherAttributionInfo: 'Parcela das vendas do ano atribuída a este investimento, de 0% a 100%. Obrigatória quando há um total.',
  otherAttributionInfoCompetition: 'Parcela das vendas do ano que a concorrência tira, de -100% a 0%. Obrigatória quando há um total.',
  otherAttributionHint: '≈ {amount} em vendas',
  otherAttributionHeld: 'Limitada a {cap}%: o marketing, a sazonalidade e a concorrência não deixam mais margem.',
  otherAttributionBlank: 'Obrigatória.',
  stepHintOtherAttribution: 'Informe a atribuição de cada input com total para continuar.',
  otherAttributionNeedsSpend: 'Informe um total primeiro.',
  decompositionComarketingName: 'Co-marketing',
  decompositionCompetitionName: 'Concorrência',
  decompositionComarketing: 'os {share}% das vendas atribuídos ao co-marketing. Saem das vendas base.',
  decompositionCompetition: 'os {share}% das vendas que a concorrência tira. Voltam para as vendas base.',
  decompositionOtherChosenByModel: 'não sobra margem para sua parcela das vendas, então o modelo vai escolhê-la. Aqui não tem barra.',
  decompositionOtherByPeriodNote: 'O co-marketing e a concorrência são distribuídos entre os meses de acordo com seu investimento. O modelo construído adiciona saturação e efeito residual, então seus meses vão diferir.',
  inputMarketingSpend: 'Investimento em mídia',
  inputSeriesName: 'Input {name}',
  otherImport: 'Importar a forma mensal de outro modelo',
  otherSheetShow: 'Editar como tabela',
  marketRequired: 'O mercado é obrigatório.',
  noSourceModels: 'Não há modelos com relatório concluído.',
  noCopyModels: 'Não há modelos disponíveis para copiar.',
  catalogueRestricted: 'Só aparecem os modelos aos quais você tem acesso.',
  reportEmpty: 'Este modelo ainda não tem relatório.',
  reportLoadFailed: 'Não foi possível carregar o relatório deste modelo: {error}',
  // Como uma composição começa
  sourceQuestion: 'Como você quer começar?',
  sourceScratch: 'Do zero',
  sourceScratchNote: 'Adicione canais dos seus modelos, um por um.',
  sourceCopy: 'Copiar um modelo',
  sourceCopyNote: 'Parta de um modelo existente e edite-o.',
  copyModel: 'Modelo a copiar',
  copyName: '{name} (cópia)',
  copyFailed: 'Não foi possível carregar este modelo.',
  copyNothing: 'Nenhum canal deste modelo pode ser copiado.',
  copyDone: '{channels} canal copiado, com vendas de {revenue}. Você pode editar tudo nas próximas etapas. | {channels} canais copiados, com vendas de {revenue}. Você pode editar tudo nas próximas etapas.',
  copySkippedTitle: 'Canais que não puderam ser copiados',
  copyHeldMonths: 'A sazonalidade de {months} foi limitada a {cap}% das vendas base.',
  copyAskTitle: 'Substituir seus canais?',
  copyAsk: 'Copiar um modelo substitui o canal que você adicionou e tudo o que configurou nele. | Copiar um modelo substitui os {channels} canais que você adicionou e tudo o que configurou neles.',
  copyAskConfirm: 'Substituir',
  // Adicionar canais
  addChannels: 'Adicionar canais',
  importFromModels: 'Importar de modelos',
  importFromModelsNote: 'Pegue canais, com suas curvas, de modelos existentes.',
  chooseModel: 'Escolher modelo…',
  changeModel: 'Trocar',
  copyImporterTitle: 'Escolha um modelo para copiar',
  copyImporterSubtitle: 'Busque pelo nome ou filtre por país, cliente, marca ou categoria.',
  channelImporterTitle: 'Importar canais',
  channelImporterSubtitle: 'Busque por modelo ou canal, e filtre por dados do modelo ou taxonomia do canal.',
  importerSearchModels: 'Buscar modelos',
  importerSearchChannels: 'Buscar canais ou modelos',
  importerModelFacets: 'Modelo',
  importerTaxonomyFacets: 'Taxonomia do canal',
  importerNoMetadata: 'Estes modelos ainda não têm metadados. Você pode buscá-los pelo nome.',
  importerNoModelMatch: 'Nenhum modelo corresponde a estes filtros.',
  importerNotSet: 'Não definido',
  importerCurrent: 'Atual',
  importerChangeModel: 'Trocar modelo',
  importerAllChannels: 'Selecionar todos os canais de {model}',
  importerPickHint: 'Clique em um modelo para escolhê-lo.',
  importerFacetCountry: 'País',
  importerFacetClient: 'Cliente',
  importerFacetBrand: 'Marca',
  importerFacetCategory: 'Categoria',
  importerFacetSubcategory: 'Subcategoria',
  addFromScratch: 'Do zero',
  addFromScratchNote: 'Crie um canal e defina você mesmo suas curvas.',
  taxonomyFilters: 'Filtros',
  taxonomyClear: 'Limpar filtros',
  taxonomyRemoveFilter: 'Remover filtro',
  taxonomyOnlyClassified: 'Só canais classificados',
  taxonomyUnclassified: 'Sem classificação',
  taxonomyShowAll: 'Ver todos ({count})',
  taxonomyShowLess: 'Ver menos',
  taxonomyShowMore: 'Ver mais',
  taxonomyShowing: 'Mostrando {shown} de {total}',
  taxonomyNoMatch: 'Nenhum canal corresponde a estes filtros.',
  taxonomyNoneYet: 'Nenhum canal tem taxonomia ainda. Você pode buscá-los pelo nome.',
  taxonomyCatalogueLoading: 'Carregando modelos…',
  taxonomyReading: 'Lendo {count} modelo… | Lendo {count} modelos…',
  taxonomyModels: '{count} modelo | {count} modelos',
  taxonomySummary: '{channels} de {models}',
  taxonomyNotInReport: 'Este canal não está no relatório do seu modelo.',
  taxonomyReadFailed: 'Não foi possível carregar o relatório deste modelo.',
  scratchChannel: 'Canal novo',
  fromScratchOrigin: 'Do zero',
  pickerAdd: 'Adicionar canais | Adicionar {count} canal | Adicionar {count} canais',
  pickerAlready: 'Já adicionado',
  pickerModelAdded: '{count} canal já adicionado | {count} canais já adicionados',
  pickerAddHint: 'Adicionar os canais selecionados (⌘/Ctrl + Enter)',
  pickerNotMeasured: 'Sem medição',
  pickerAdded: 'Adicionado',
  pickerPlotSaturation: 'Saturação: vendas geradas por cada nível de investimento mensal.',
  pickerPlotDecay: 'Decaimento: como o efeito se prolonga nos meses seguintes.',
  pickerLoadingNote: 'Carregando o modelo…',
  pickerCount: '{count} canal | {count} canais',
  pickerSelected: '{count} selecionados',
  pickerSelectAll: 'Selecionar todos os canais visíveis',
  notReadyTitle: 'Este modelo não pode fornecer canais',
  notReady_noKpi: 'Ele não tem histórico de vendas.',
  notReady_noChannels: 'Nenhum dos seus canais tem ao mesmo tempo histórico de investimento e curva de saturação.',
  skipped_noSaturation: '{channel}: sem curva de saturação utilizável.',
  skipped_noCurve: '{channel}: sua curva de saturação tem poucos pontos.',
  unbuiltAction: 'Completar',
  channelEditTitle: 'Editar {channel}',
  channelName: 'Nome do canal',
  editorPrev: 'Canal anterior',
  editorNext: 'Próximo canal',
  saturationCurve: 'Curva de saturação',
  saturationPoint: 'Ponto de saturação',
  responseShape: 'Forma da resposta',
  // Decaimento
  decayTitle: 'Decaimento',
  decayLagAt: 'Mês {month}',
  decayImported: 'Como importado',
  decayCustom: 'Personalizado',
  decayPeak: 'Pico {month}',
  decayShapeTitle: 'Pico no mês {peak}; metade do efeito até o mês {half}',
  decayDrag: 'Arraste a barra mais alta: na horizontal para mover o pico, na vertical para mudar a velocidade com que o efeito some.',
  decayShapeNow: 'Pico no mês {peak} · metade do efeito até o mês {half}',
  decayAbout: 'Como o investimento de um mês continua funcionando nos meses seguintes: muda quando as vendas chegam, não quantas. Canais de modelos semanais precisam que você escolha uma forma aqui.',
  statedOf: '{index} de {count}',
  statedSuffix: 'USD / mês',
  unbuiltBlocked: 'Sem curva disponível',
  unbuiltChannel: 'Indique onde {channel} satura e suas vendas nesse ponto para incluí-lo no modelo.',
  unbuiltNoCurve: 'A curva de saturação de {channel} nunca se estabiliza, então não pode ser usada. Remova-o e escolha outro canal.',
  // Investimento em mídia
  metricSpend: 'Investimento em mídia',
  metricSpendTotal: 'Investimento total',
  metricSpendInfo: 'Investimento total em mídia no ano. Escolha um nível no gráfico ou informe um ROAS total desejado.',
  metricTotalKpi: 'Vendas totais',
  metricTotalKpiInfo: 'Vendas totais do ano. Definem quanto do negócio o marketing explica, e seus limites dependem do investimento em mídia.',
  metricAvgMonth: 'Média por mês',
  metricAvgMonthInfo: 'Média mensal. Ao editá-la, o total é atualizado.',
  metricRoas: 'ROAS total',
  metricRoasInfo: 'ROAS total estimado: vendas geradas pela mídia divididas pelo investimento em mídia. O modelo construído pode variar um pouco.',
  tradePlotLabel: 'Retorno por investimento',
  tradeMinLabel: 'Invest. mín.',
  trade_min_attribution: 'Investimento mínimo: abaixo dele, o marketing quase não explicaria as vendas.',
  trade_min_floor: 'Investimento mínimo: abaixo dele, o investimento mensal de alguns canais seria baixo demais para modelar.',
  trade_min_window: 'Menor investimento do gráfico. Clique para ir até ele.',
  tradeMaxLabel: 'Invest. máx.',
  trade_max_revenue: 'Investimento máximo: acima dele, o investimento em mídia superaria as vendas.',
  trade_max_base: 'Investimento máximo: acima dele, a mídia receberia mais do que as vendas totais.',
  trade_max_attribution: 'Investimento máximo: acima dele, a mídia receberia quase todas as vendas.',
  trade_max_window: 'Maior investimento do gráfico. Clique para ir até ele.',
  spendSeated: 'O investimento em mídia foi ajustado para {spend}, o limite deste modelo.',
  spendSeatedChannels: 'O investimento em mídia foi ajustado para {spend}, o limite para os canais restantes.',
  spendSeatedCurves: 'O investimento em mídia foi ajustado para {spend}, o limite após as mudanças nas curvas.',
  spendSeatedMonths: 'O investimento em mídia foi ajustado para {spend}, o limite após as mudanças mensais.',
  spendHeld: 'O investimento em mídia foi mantido em {spend}.',
  // Vendas mantidas ou ajustadas para ficar dentro dos limites
  revenueHeld_spend: 'As vendas foram mantidas em {revenue}: precisam ser maiores que o investimento em mídia. Reduza o investimento para ir mais abaixo.',
  revenueSeated_spend: 'As vendas foram ajustadas para {revenue} para ficar acima do investimento em mídia. Reduza o investimento para ir mais abaixo.',
  monthHeld_spend: '{month} foi mantido em {amount}: as vendas do ano precisam ser maiores que o investimento em mídia.',
  revenueHeld_base: 'As vendas foram mantidas em {revenue}, o mínimo para este investimento em mídia. Reduza o investimento para ir mais abaixo.',
  revenueSeated_base: 'As vendas foram ajustadas para {revenue}, o mínimo para o investimento em mídia atual. Reduza o investimento para ir mais abaixo.',
  monthHeld_base: '{month} foi mantido em {amount}: abaixo disso, a mídia receberia mais do que as vendas totais.',
  revenueFloorHint: 'Mínimo com este investimento: {revenue}',
  revenueHeld_low: 'As vendas foram mantidas em {revenue}, o mínimo permitido.',
  revenueHeld_high: 'As vendas foram mantidas em {revenue}: acima disso, a mídia quase não explicaria as vendas. Adicione canais ou aumente o investimento em mídia.',
  revenueSeated_low: 'As vendas foram ajustadas para {revenue}, o mínimo permitido.',
  revenueSeated_high: 'As vendas foram ajustadas para {revenue}, o máximo para o investimento em mídia atual. Aumente o investimento para ir mais acima.',
  tradePeakLabel: 'ROAS máx.',
  tradePeak: 'Maior retorno por dólar. Além dele, cada dólar extra rende menos. Clique para ir até ele.',
  baseBelowFloor: 'As vendas base estão abaixo do mínimo de {floor} para este investimento em mídia. Aumente as vendas para {revenue} ou mais, ou reduza o investimento em mídia.',
  roasOutOfReach: 'Não é possível alcançar este ROAS total. Com este mix ele vai de {min} a {max}.',
  roasUnsolvable: 'Nenhum investimento em mídia alcança este ROAS total.',
  roasOutOfReachEither: 'Não é possível alcançar este ROAS total. Com este mix ele vai de {min} a {max}; com qualquer mix, de {mixMin} a {mixMax}.',
  roasHeldAt: 'Ajustado até onde as curvas permitem: o ROAS total agora é {roas}.',
  roasHeldFloor: 'Esse ROAS total exigiria deixar um canal quase sem investimento, então o investimento foi ajustado até onde foi possível.',
  mixMoved: 'Para alcançar este ROAS total, o orçamento foi redistribuído entre os canais. As curvas não mudaram.',
  spendMonthsLabel: 'Investimento mensal',
  spendMonthsKeys: 'Tab: próximo campo · Enter: aplicar · Esc: cancelar',
  shapeMonthsKeys: 'Tab: próximo campo · Enter: aplicar · Esc: cancelar',
  spendSheetChannels: 'Canal',
  spendSheetShow: 'Editar como tabela',
  sheetHide: 'Ocultar tabela',
  revenueSheetShow: 'Editar como tabela',
  sharesSheetShow: 'Editar como tabela',
  sheetSeries: 'Série',
  revenueSheetHeld: 'As vendas de {months} foram ajustadas para ficar dentro do intervalo permitido.',
  shareSheetCell: '{row} em {month} ({value}% da base)',
  shareSheetHeld: '{cells} foram ajustados para ficar dentro do intervalo permitido. {reasons}',
  shapeUnit: '% da base',
  shapeCapNote: 'Cada valor é uma parcela das vendas base daquele mês. Juntos, a sazonalidade e os eventos pontuais podem ocupar até {cap}% da base de um mês.',
  spendReturnKpi: 'Vendas',
  roasAxis: 'Vendas / Investimento',
  // Prévia
  previewModelName: 'Prévia do modelo',
  decayAxis: 'Meses após o investimento',
  decompositionIntro: 'De onde vêm as vendas deste modelo:',
  decompositionBase: 'as vendas sem nenhuma mídia. O relatório do modelo construído vai dividi-las em base e ruído.',
  decompositionSeasonality: 'a parcela das vendas que vem de padrões anuais recorrentes. Ela move vendas entre meses, então no ano costuma somar perto de zero.',
  decompositionMarketingTerm: 'Marketing',
  decompositionMarketing: 'as vendas geradas por todos os canais com o investimento em mídia atual.',
  decompositionBaseBelowFloor: 'A sazonalidade e os eventos pontuais ocupam {claimed} dos {room} disponíveis e deixam as vendas base abaixo do mínimo de {floor}. Reduza-os, ou diminua o investimento em mídia e aumente as vendas.',
  decompositionBaseNoRoom: 'A mídia já explica todas as vendas exceto a base mínima de {floor}, então não sobra margem para sazonalidade nem eventos pontuais. Reduza o investimento em mídia ou aumente as vendas.',
  // Vendas por mês
  metricRevenueShape: 'Vendas',
  metricRevenueShapeInfo: 'Como as vendas totais se distribuem entre os meses. Use os botões para mudar a forma, deslocar ou importar o ano, ou clique em um mês para editá-lo.',
  shapeRandomize: 'Aleatorizar: deixar os meses mais irregulares',
  shapeFlatten: 'Suavizar: deixar os meses mais uniformes',
  shapeClear: 'Limpar',
  shapeShiftLeft: 'Antecipar um mês',
  shapeShiftRight: 'Adiar um mês',
  shapeImport: 'Importar a forma mensal de outro modelo',
  shapeImportTitle: 'Importar a forma das vendas',
  shapeImportSubtitle: 'Use o padrão mensal de vendas de outro modelo. Seu total não muda.',
  shapeImportKpi: 'KPI',
  shapeImportTotal: 'Total',
  shapeImportYear: 'Ano',
  shapeImportAverage: 'Média de {count} anos completos',
  shapeImportLoadingNote: 'Carregando o relatório…',
  shapeImportNoYears: 'Este modelo não tem nenhum ano-calendário completo.',
  shapeImportNoShape: 'Este KPI não tem vendas no ano escolhido.',
  shapeImportNote: 'Só são usados anos-calendário completos. Seu total não muda.',
  shapeImportShiftLeft: 'Antecipar um mês',
  shapeImportShiftRight: 'Adiar um mês',
  shapeImportShifted: 'Deslocado {count} mês | Deslocado {count} meses',
  shapeImportSeason: 'Importar a sazonalidade de outro modelo',
  shapeShiftSeasonLeft: 'Antecipar um mês',
  shapeShiftSeasonRight: 'Adiar um mês',
  shapeRandomizeSeason: 'Aleatorizar: acentuar a sazonalidade',
  shapeFlattenSeason: 'Suavizar: aproximar as duas linhas de zero',
  shapeClearSeason: 'Limpar',
  shapeImportSeasonTitle: 'Importar a sazonalidade',
  shapeImportSeasonSubtitle: 'Use a sazonalidade medida em outro modelo. Os eventos pontuais não são importados.',
  shapeImportSeasonNoShape: 'Este modelo não tem sazonalidade no ano escolhido.',
  shapeImportSeasonNote: 'Só são usados anos-calendário completos. Os meses acima do teto são limitados a ele.',
  shapeImportSeasonApply: 'Usar esta sazonalidade',
  shapeImportHeldMonths: '{months} será limitado a {cap}% das vendas base.',
  shapeImportApply: 'Usar esta forma',
  shapeImportOtherTitle: 'Importar a forma',
  shapeImportOtherSubtitle: 'Use o padrão mensal de uma série de mídia ou externa de outro modelo. O total não muda.',
  shapeImportOtherSeries: 'Série',
  shapeImportOtherMedia: 'Mídia',
  shapeImportOtherMediaTotal: 'Investimento total em mídia',
  shapeImportOtherExternal: 'Externas',
  shapeImportOtherNoSeries: 'Este modelo não tem séries de mídia nem externas.',
  shapeImportOtherNoShape: 'Esta série está vazia ou é negativa no ano escolhido.',
  shapeImportOtherNote: 'Só são usados anos-calendário completos. O total não muda.',
  shapeImportOtherNeedsTotal: 'Informe um total primeiro.',
  shapeImportOtherApply: 'Usar esta forma',
  monthHeld_low: '{month} foi mantido em {amount}, o mínimo permitido.',
  monthHeld_high: '{month} foi mantido em {amount}: acima disso, a mídia quase não explicaria as vendas.',
  // Sazonalidade e eventos pontuais
  metricSeasonality: 'Sazonalidade',
  seasonalitySection: 'Sazonalidade',
  metricSeasonalityNet: 'Líquido do ano',
  metricSeasonalityNetInfo: 'Soma da sazonalidade no ano. É normal ficar perto de zero: ela move vendas entre meses.',
  seasonalityAbout: 'Padrões anuais recorrentes, como % das vendas base de cada mês. Começa plana.',
  seasonality_stop_attribution: 'Além deste ponto, a atribuição deixaria de somar 100%.',
  shapesSection: 'Sazonalidade e eventos pontuais',
  shapesOptional: 'Opcional',
  metricShapesNet: 'Líquido do ano',
  metricSpot: 'Eventos pontuais',
  spotSection: 'Eventos pontuais',
  metricSpotNet: 'Líquido do ano',
  metricSpotNetInfo: 'Soma dos eventos pontuais no ano. Diferente da sazonalidade, eles não se compensam.',
  spotAbout: 'Eventos únicos, como um lançamento, uma promoção ou uma ruptura de estoque, como % das vendas base daquele mês.',
  shapesHow: 'Clique em um mês para editar os dois valores. Eles saem das vendas base e são limitados pelo teto mostrado acima do gráfico.',
  spot_stop_attribution: 'Além deste ponto, a atribuição deixaria de somar 100%.',
  decompositionSpot: 'a parcela das vendas que vem de eventos únicos. Sai das vendas base.',
  // Cartões de canal
  channels: 'Canais',
  channelsInfoMixed: 'O orçamento não está mais dividido igualmente entre os canais.',
  channelRemove: 'Remover {channel}',
  channelRemoveLast: 'Um modelo precisa de pelo menos um canal.',
  channelRemoveTitle: 'Remover este canal?',
  channelRemoveText: '{channel} e todas as suas configurações serão removidos. Esta ação não pode ser desfeita.',
  channelRemoveConfirm: 'Remover',
  channelNameEmpty: 'Informe um nome para o canal.',
  channelNameTaken: 'Já existe outro canal com este nome.',
  fromModel: '{model} · {channel}',
  saturation: 'Saturação',
  decay: 'Decaimento',
  noCurve: 'Sem curva',
  spend: 'Investimento',
  lagMonths: 'Meses',
  cardPoint: '{channel} satura em {knee} USD por mês e gera {ceiling} USD por mês nesse ponto. Clique para editar.',
  cardPointUnstated: 'Ponto de saturação não definido. Clique para defini-lo.',
  channelKnee: 'Satura em',
  channelKneeTitle: 'Investimento mensal a partir do qual {channel} deixa de compensar: além dele, cada dólar extra rende cada vez menos.',
  channelCeiling: 'Vendas na saturação',
  channelCeilingTitle: 'Vendas mensais que {channel} gera no seu ponto de saturação.',
  // Editor de canal
  revenue: 'Vendas',
  curveEditAction: 'Editar canal',
  curveEditMoved: 'Editar {channel} (a linha tracejada é a curva original)',
  editorSaveNext: 'Salvar e completar o próximo',
  editorSave: 'Salvar',
  editorCancel: 'Cancelar',
  editorLeaveTitle: 'Alterações não salvas',
  editorLeaveText: 'Se fechar agora, as alterações em {channel} serão perdidas.',
  editorLeaveStepText: 'Se passar para outro canal, as alterações em {channel} serão perdidas.',
  editorLeaveSave: 'Salvar',
  editorLeaveDiscard: 'Descartar',
  editorLeaveStay: 'Continuar editando',
  curveReset: 'Voltar ao original',
  curveCeiling: 'Vendas máximas',
  curveKneeInfo: 'Investimento mensal com o qual o canal atinge metade das suas vendas máximas. Mova para a direita para que sature mais tarde.',
  curveCeilingInfo: 'O máximo que este canal pode gerar, não importa quanto se invista.',
  curveKnee: 'Investimento de meia saturação',
  curveSteepness: 'Inclinação',
  curveSteepnessInfo: 'Quão acentuada é a curva. Acima de 1, o canal precisa de um investimento mínimo antes de começar a funcionar.',
  curveSeriesCurrent: 'Atual',
  curveSeriesOriginal: 'Original',
  curveNoteSampled: 'Estes controles não reproduzem exatamente a curva original, então mover um também muda sua forma.',
  zonesBegin: 'Zonas ótimas',
  zoneBegins: 'Onde começa a {zone}',
  zoneDrag: 'Arraste para mover onde começa a {zone}',
  zonesHold: 'Manter fixo:',
  zonesHoldSaturation: 'Ponto de saturação',
  zonesHoldSaturationHint: 'Ao arrastar, a forma da curva muda; o ponto de saturação não se move.',
  zonesHoldShape: 'Forma',
  zonesHoldShapeHint: 'Ao arrastar, todas as zonas se deslocam juntas; o ponto de saturação se move com elas.',
  zonesHoldEdgeHint: 'Onde começa a {zone} não se move; os outros limites e o ponto de saturação, sim.',
  zonesNone: 'Esta curva é plana demais para ter zonas ótimas. Aumente a Inclinação para recuperá-las.',
  zonesNoneSimple: 'Esta curva é plana demais para ter zonas ótimas. Abra Forma da resposta e aumente a Inclinação para recuperá-las.',
  zonesHeld: 'Este limite é o ponto de saturação, que está fixo. Edite-o no campo ao lado do gráfico.',
  zonesHeldEdge: 'Este limite está fixo. Fixe outra coisa para poder arrastá-lo.',
  zonesHow: 'Arraste ou digite um limite para mover as zonas. O seletor acima da barra define o que fica fixo enquanto isso.',
  curve_stop_attribution: 'Além deste ponto, a atribuição de marketing ficaria fora do intervalo.',
  curve_stop_base: 'Além deste ponto, a mídia receberia mais do que as vendas totais.',
  curve_stop_floor: 'Além deste ponto, o canal geraria menos de 1 USD por mês.',
  curveAboutTitle: 'Editor de canal',
  curveAbout: 'Vendas que este canal gera em cada nível de investimento mensal, tiradas do seu modelo de origem. As alterações só afetam o modelo novo.',
  curveHow: 'Os três controles definem a forma da curva. Mudá-la muda o que o mesmo investimento gera.',
  responseShapeHint: 'Ajuste a curva com a Inclinação, o Investimento de meia saturação e as Vendas máximas.',
  zonesAdjust: 'Ajustar zonas',
  zonesAdjustHint: 'Arraste os limites das zonas e escolha o que fica fixo.',
  curveSimple: 'A curva é definida pelo ponto de saturação e suas vendas. Abra Forma da resposta para ajustar sua forma.',
  // Salvar
  checkTitle: 'Antes de criar',
  createAnyway: 'Criar mesmo assim',
  goBack: 'Voltar'
}
